module.exports = __webpack_public_path__ + "blog-two-body.jpg?389ca65db808f896e4a57ff9497d7f47";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/blog-two-body.jpg
// module id = 127
// module chunks = 0